module.exports = __webpack_public_path__ + "img/cons_2.88fab288.jpg";